module.exports = [
	{
		"componentChunkName": "component---node-modules-gatsby-plugin-offline-app-shell-js",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "offline-plugin-app-shell-fallback.json",
		"path": "/offline-plugin-app-shell-fallback/"
	},
	{
		"componentChunkName": "component---src-templates-post-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "post-one.json",
		"path": "/post-one"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "start-the-environment.json",
		"path": "/start-the-environment"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "configure-the-application-schema-for-caaml.json",
		"path": "/configure-the-application-schema-for-caaml"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "clean-data.json",
		"path": "/clean-data"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "caaml-model-design.json",
		"path": "/caaml-model-design"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "wcs-examples.json",
		"path": "/wcs-examples"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "wms-examples.json",
		"path": "/wms-examples"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "wfs-examples.json",
		"path": "/wfs-examples"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "wps-examples.json",
		"path": "/wps-examples"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "introduction-to-ogc.json",
		"path": "/introduction-to-ogc"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "introduction-to-caaml.json",
		"path": "/introduction-to-caaml"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "data-and-geospatial-tools.json",
		"path": "/data-and-geospatial-tools"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "introduction-to-inspire.json",
		"path": "/introduction-to-inspire"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "introduction-to-wcs.json",
		"path": "/introduction-to-wcs"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "introduction-to-wps.json",
		"path": "/introduction-to-wps"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "introduction-to-wfs.json",
		"path": "/introduction-to-wfs"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "introduction-to-wms.json",
		"path": "/introduction-to-wms"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "lesson-six.json",
		"path": "/lesson-six"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "push-the-configuration-to-geo-avalanche.json",
		"path": "/push-the-configuration-to-geo-avalanche"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "populate-region.json",
		"path": "/populate-region"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "query-our-region-features.json",
		"path": "/query-our-region-features"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "load-data.json",
		"path": "/load-data"
	},
	{
		"componentChunkName": "component---src-templates-category-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "categories-tech.json",
		"path": "/categories/tech/"
	},
	{
		"componentChunkName": "component---src-pages-about-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "about.json",
		"path": "/about/"
	},
	{
		"componentChunkName": "component---src-pages-index-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "index.json",
		"path": "/"
	}
];


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = 430
// module chunks = 231608221292675